import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';

export function configure(config: FrameworkConfiguration): void {
  
	config.globalResources([

		PLATFORM.moduleName('../components/comp-navigation/comp-navigation'),
		PLATFORM.moduleName('../components/comp-theme-toggle/comp-theme-toggle'),
		PLATFORM.moduleName('../components/comp-icon/comp-icon'),
		PLATFORM.moduleName('../components/comp-theme-picker/comp-theme-picker'),
	]);
}